import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReviewRmsPlanChecklistComponent } from "../../../../components/review-content/review-rms-plan-checklist/review-rms-plan-checklist.component";

@Component({
  selector: 'rms-checklist-submission',
  standalone: true,
  imports: [
    CommonModule,
    ReviewRmsPlanChecklistComponent
],
  templateUrl: './rms-checklist-submission.component.html',
  styleUrl: './rms-checklist-submission.component.css'
})
export class RmsChecklistSubmissionComponent implements OnInit {

  @Input() rmsPlanChecklistData: any;
  @Output() onSaveSection7 = new EventEmitter<any>();

  currentCaseId: string | null = null;

  ngOnInit(): void {
    if (this.rmsPlanChecklistData) {
      this.currentCaseId = this.rmsPlanChecklistData.case_id;
    }
  }

  submitRmsPlanChecklist(): void {
    this.onSaveSection7.emit({});
  }

}
